<template>
    <div id="ambis-meter-edit-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Meter',
                    to: { path: '/ambis-meter' },
                },
                { text: 'Ubah Ambis Meter' },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ "Ubah Ambis Meter" }}
        </h3>

        <v-card>
            <v-tabs>
                <v-tab>Periode</v-tab>
                <v-tab>Kelas dan Misi</v-tab>
                <v-tab>Level</v-tab>
                <v-tab-item>
                    <div class="mx-5 my-5">
                        <app-periode-editform></app-periode-editform>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="mx-5 my-5">
                        <app-mission-editform></app-mission-editform>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="mx-5 my-5">
                        <app-level-editform></app-level-editform>
                    </div>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
import PeriodeEditForm from "@/modules/ambis_meter/components/PeriodeEditForm";
import MissionEditForm from "@/modules/ambis_meter/components/MissionEditForm";
import LevelEditForm from "@/modules/ambis_meter/components/LevelEditForm";

export default {
    name: "ambis-meter-edit-form",

    components: {
        "app-periode-editform": PeriodeEditForm,
        "app-mission-editform": MissionEditForm,
        "app-level-editform": LevelEditForm,
    },
};
</script>



// WEBPACK FOOTER //
// AmbisMeterEditForm.vue?47764513